import React from "react";
import { Spinner, Text, SpinnerProps } from "@fluentui/react-components";
import { Box } from "../../../theme/fluent";

interface LoadingSpinnerProps {
  size?: SpinnerProps["size"];
  showText?: boolean;
  text?: string;
  subText?: string;
  fullHeight?: boolean;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = "large",
  showText = false,
  text = "Loading...",
  subText,
  fullHeight = true,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap="m"
      py="xl"
      style={{
        ...(fullHeight && {
          height: "100%",
          minHeight: "200px",
        }),
      }}
    >
      <Spinner role={"progressbar"} size={size} aria-label={text} />
      {showText && (
        <>
          <Text size={300} weight="semibold" style={{ textAlign: "center" }}>
            {text}
          </Text>
          {subText && (
            <Text size={200} style={{ textAlign: "center" }}>
              {subText}
            </Text>
          )}
        </>
      )}
    </Box>
  );
};
